import { Ng2StateDeclaration, Transition } from '@uirouter/angular';
import { LoggingService } from '../../shared/services/logging/logging.service';
import { PayrollExportContainerComponent } from './payroll-export-container/payroll-export-container.component';
const log = new LoggingService();

export const PayrollExportRoute: Ng2StateDeclaration = {
    // name: 'PayrollExport.**'
    name: 'sendpayroll',
    url: '/sendpayroll',
    // , loadChildren: () => import('./payroll-export.module').then(r => r.PayrollExportModule)
    data: { requiresAuth: true },

    component: PayrollExportContainerComponent
};
